export const formatYearsOfExperience = (
  value: number | null | undefined
): string => {
  if (typeof value !== 'number' || !Number.isFinite(value) || value < 0) {
    return '';
  }

  return `${Math.round(value * 10) / 10} yr`;
};
